export default function StatsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-sm font-serif text-gray-500 mb-2">Why Trust Us</p>
          <h2 className="text-5xl font-bold text-gray-900 mb-2">Real Testing,</h2>
          <h3 className="text-5xl font-serif italic text-orange-500 mb-2">Real Results</h3>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We don't just read spec sheets. Every product is tested in actual off-grid conditions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-orange-600 to-orange-500 p-12 rounded-2xl relative overflow-hidden group hover:shadow-2xl transition-all duration-300">
            <div className="absolute top-6 right-6">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full group-hover:scale-110 transition-transform cursor-pointer">
                <i className="ri-arrow-right-up-line text-2xl text-white"></i>
              </div>
            </div>

            <div className="text-7xl font-serif font-bold text-white mb-4">500+</div>
            <p className="text-xl text-white/90 mb-2">Products rigorously tested in real off-grid environments</p>
            <p className="text-lg font-serif italic text-white/80">Products Tested</p>
          </div>

          <div className="bg-gray-900 p-12 rounded-2xl relative overflow-hidden group hover:shadow-2xl transition-all duration-300">
            <div className="absolute top-6 right-6">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-500/20 backdrop-blur-sm rounded-full group-hover:scale-110 transition-transform cursor-pointer">
                <i className="ri-arrow-right-up-line text-2xl text-orange-500"></i>
              </div>
            </div>

            <div className="text-7xl font-serif font-bold text-orange-500 mb-4">98%</div>
            <p className="text-xl text-white/90 mb-2">
              Reader satisfaction rate based on purchase decisions made from our honest reviews and recommendations
            </p>
            <p className="text-lg font-serif italic text-white/70">Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
}
